import { Snowflake, Scissors, ShieldCheck, Thermometer, Factory, Truck } from "lucide-react";
import { SectionHeader } from "@/components/SectionHeader";
import { Stagger, Item } from "@/components/Reveal";
import { useLang } from "@/i18n/LanguageContext";

const ICONS = [Factory, Scissors, Snowflake, ShieldCheck, Thermometer, Truck];
const IDS = ["manufacturing-supply", "custom-cut-pack", "iqf-programs", "coa-traceability", "cold-chain-integrity", "delivery"];

export const Capabilities = ({ compact = false }) => {
  const { t } = useLang();
  const c = t.caps;
  return (
  <section className="relative bg-[var(--ink)] py-24 text-white lg:py-32" data-testid="capabilities-section">
    <div className="pointer-events-none absolute right-0 top-0 h-[400px] w-[400px] rounded-full bg-[var(--green)]/30 blur-[140px]" />
    <div className="mx-auto max-w-7xl px-6 lg:px-10">
      <SectionHeader light eyebrow={c.eyebrow} title={c.title} text={c.text} />
      <Stagger className={`mt-16 grid gap-px overflow-hidden rounded-3xl border border-white/10 bg-white/10 sm:grid-cols-2 ${compact ? "lg:grid-cols-3" : "lg:grid-cols-3"}`}>
        {c.list.map((item, i) => {
          const Icon = ICONS[i];
          return (
          <Item key={item.title} className="group bg-[var(--ink)] p-8 transition-colors duration-500 hover:bg-[var(--green-deep)]">
            <div data-testid={`capability-${IDS[i]}`}>
              <Icon size={26} className="text-[var(--lime)] transition-transform duration-500 group-hover:-translate-y-1" />
              <h3 className="font-display mt-6 text-xl font-semibold">{item.title}</h3>
              <p className="mt-3 text-sm leading-relaxed text-white/65">{item.text}</p>
            </div>
          </Item>
          );
        })}
      </Stagger>
    </div>
  </section>
  );
};
